import React, { useState, useEffect } from "react";
import { FaWhatsapp, FaArrowUp, FaPhoneAlt } from "react-icons/fa";

export default function FloatingButtons() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowTop(window.scrollY > 300);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const whatsappNumber = "918590999451";
  const callNumber = "918590300370";
  const message = `Hello Doctor,

I would like to book an appointment at Dr. Sainulabid's IQRA Multispeciality Dental Clinic.

Name:
Preferred Date:
Preferred Time:`;

  return (
    <>
      {/* ✅ Call Button - Brand color teal */}
      <a 
        href={`tel:+${callNumber}`} 
        className="fixed left-5 bottom-[calc(env(safe-area-inset-bottom)+20px)] z-50 bg-[#2CA6B1] hover:bg-[#23949D] text-white p-3.5 md:p-4 rounded-full shadow-lg hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300"
        aria-label="Call us"
      >
        <FaPhoneAlt size={20} className="md:text-[22px]" />
      </a>
      
      {/* ✅ WhatsApp Button - Pulse animation */}
      <a 
        href={`https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`} 
        target="_blank" 
        rel="noreferrer" 
        className="fixed right-5 bottom-[calc(env(safe-area-inset-bottom)+20px)] z-50 bg-green-500 text-white p-3.5 md:p-4 rounded-full shadow-lg hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 animate-pulseSlow"
        aria-label="WhatsApp us"
      >
        <FaWhatsapp size={22} className="md:text-[26px]" />
      </a>
      
      {/* ✅ Scroll to Top Button */}
      {showTop && (
        <button 
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })} 
          className="fixed right-5 bottom-[calc(env(safe-area-inset-bottom)+90px)] z-50 bg-[#1E293B] text-white p-2.5 md:p-3 rounded-full shadow-lg hover:shadow-2xl hover:scale-110 active:scale-95 transition-all duration-300 hover:bg-teal-600"
          aria-label="Scroll to top"
        >
          <FaArrowUp size={16} className="md:text-[18px]" />
        </button>
      )}
    </>
  );
}